import PinhoverIcon from './component'

export default PinhoverIcon
